import ProductDetailsStep from './DetailsStep';

export default ProductDetailsStep;
